export default __webpack_public_path__ + "static/media/ten.8ffa4bbb.ogg";